import React, { useState } from "react";
import { API } from "../API";
import { ConvertImportedVisit, ImportedVisitId } from "../messages";
import { ConvertImportedVisitScreen } from "./ConvertImportedVisitScreen";

interface Props {
  api: API;
  importedVisitId: ImportedVisitId;
  patientName: string;
  onBackClick: () => void;
}

const ConvertImportedVisitActivity = (props: Props) => {
  const [convertResponse, setConvertResponse] = useState<ConvertImportedVisit | null>(null);
  const [patientPhoneNumber, setPatientPhoneNumber] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChangePhoneNumber = React.useCallback((value: string) => {
    setConvertResponse(null);
    setPatientPhoneNumber(value);
  }, []);

  const handleConvertVisit = async (patientAddress: string | null) => {
    setIsLoading(true);
    const response = await props.api.convertImportedVisit(
      props.importedVisitId,
      "+1" + patientPhoneNumber,
      patientAddress
    );

    setIsLoading(false);
    setConvertResponse(response);
  };

  return (
    <ConvertImportedVisitScreen
      patientName={props.patientName}
      patientPhoneNumber={patientPhoneNumber}
      isLoading={isLoading}
      onChangePhoneNumber={handleChangePhoneNumber}
      onSubmitPhoneNumber={() => handleConvertVisit(null)}
      convertResponse={convertResponse}
      onClickConvert={handleConvertVisit}
      onBackClick={props.onBackClick}
    />
  );
};

export default ConvertImportedVisitActivity;
